import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { User, UserStatus, UserRole } from '../types';

type CreateUserPayload = {
  emailAddress?: string | null;
  firstName: string;
  lastName: string;
  userRole: UserRole;
  userStatus: UserStatus;
};

export function useCreateUser({ companyId }: { companyId?: string } = {}) {
  const queryClient = useQueryClient();
  const resource = companyId ? `admin/companies/${companyId}/users` : 'users';

  const { mutateAsync, error, isLoading, reset } = useMutation<
    { data: User },
    Error,
    CreateUserPayload
  >({
    mutationFn: (values: CreateUserPayload) => api.post<User>(resource, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });

  const createUser = async (values: CreateUserPayload) => {
    return mutateAsync(values);
  };

  return {
    createUser,
    error,
    isLoading,
    reset,
  };
}
